/**
 * Configure and mount cookie consent.
 */

const { CookieConsent } = window.kaplanCookieConsent;

window.dataLayer = window.dataLayer || [];
window.gtag = window.gtag || function gtag() {
	window.dataLayer.push( arguments );
};
window.kaplanCookieConsent.enablingAnalytics = window.kaplanCookieConsent.enablingAnalytics || {};

const config = {
	optionalCookies: [
		{
			onAccept: function () {
				dataLayer.push( { event: 'enable_functional' } );
				window.gtag( 'consent', 'update', {
					'functionality_storage': 'granted',
					'personalization_storage': 'granted',
				} );
			},
			onRevoke: function () {
				window.gtag( 'consent', 'update', {
					'functionality_storage': 'denied',
					'personalization_storage': 'denied',
				} );
			},
		},
		{
			onAccept: function () {
				// Generic group trigger.
				dataLayer.push( { event: 'enable_performance' } );
				window.kaplanCookieConsent.enablingAnalytics[ 'performance' ] = true;

				if ( 'targeting' in window.kaplanCookieConsent.enablingAnalytics ) {
					dataLayer.push( {
						'event': 'enable_analytic',
					} );
				}

				window.gtag( 'consent', 'update', {
					'analytics_storage': 'granted',
				} );
			},
			onRevoke: function () {
				window.gtag( 'consent', 'update', {
					'analytics_storage': 'denied',
				} );
			},
		},
		{
			onAccept: function () {
				// Generic group trigger.
				dataLayer.push( { event: 'enable_targeting' } );
				window.kaplanCookieConsent.enablingAnalytics[ 'targeting' ] = true;

				if ( 'performance' in window.kaplanCookieConsent.enablingAnalytics ) {
					dataLayer.push( {
						'event': 'enable_analytic',
					} );
				}

				window.gtag( 'consent', 'update', {
					'ad_storage': 'granted',
					'ad_user_data': 'granted',
					'ad_personalization': 'granted',
				} );
			},
			onRevoke: function () {
				window.gtag( 'consent', 'update', {
					'ad_storage': 'denied',
					'ad_user_data': 'denied',
					'ad_personalization': 'denied',
				} );
			},
		},
	],
};

const consent = new CookieConsent( config );
consent.mount();
